import { render, staticRenderFns } from "./UAMLandingPage.vue?vue&type=template&id=638fc876"
import script from "./UAMLandingPage.vue?vue&type=script&lang=js"
export * from "./UAMLandingPage.vue?vue&type=script&lang=js"
import style0 from "./UAMLandingPage.vue?vue&type=style&index=0&id=638fc876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports